// Add your custom JS here.function FixedAnime() {
    jQuery(document).ready(function($){

      if($('.gallery-slider').length){

        $('.gallery-slider').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          dots: false,
          centerMode: true,
          focusOnSelect: true,
          arrows: true,

          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
      }

      
    if($('.carousel-works').length){
    $('.carousel-works').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 2000,
        focusOnSelect: true,
        arrows: false,
        responsive: [

          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          },
                      {
              breakpoint: 576,
              settings: {
                slidesToShow: 2,
                centerMode: false,

              }
            },

          ]
        });
    }
    

    if($('.slider-for').length){
    
      $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        asNavFor: '.slider-nav'
      });

    }

    if($('.slider-nav').length){
  
      $('.slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      });

    }






});    